var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00000064",
    width: "800px",
    height: "800px",
    viewBox: "0 0 846.66 846.66",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M631.26 619.35c27.27,0 27.27,41.47 0,41.47l-113.9 0 0 94.47c0,11.45 -9.29,20.73 -20.73,20.73l-177.89 0c-11.45,0 -20.74,-9.28 -20.74,-20.73l0 -94.47 -152.85 0c-75.19,0 -136.63,-61.44 -136.63,-136.62l0 -316.94c0,-75.19 61.44,-136.62 136.63,-136.62l525.07 0c75.18,0 136.62,61.43 136.62,136.62l0 75.67c0,27.27 -41.46,27.27 -41.46,0l0 -75.67c0,-52.29 -42.87,-95.16 -95.16,-95.16l-525.07 0c-52.3,0 -95.16,42.87 -95.16,95.16l0 316.94c0,52.29 42.87,95.15 95.16,95.15 162.04,0 324.08,0 486.11,0zm-224.66 -353.29c-27.27,0 -27.27,-41.46 0,-41.46l229.95 0c27.27,0 27.27,41.46 0,41.46l-229.95 0zm-219.11 273.34c-27.27,0 -27.27,-41.46 0,-41.46l336.26 0c27.27,0 27.27,41.46 0,41.46l-336.26 0zm0 -86.77c-27.27,0 -27.27,-41.47 0,-41.47l336.26 0c27.27,0 27.27,41.47 0,41.47l-336.26 0zm219.11 -112.81c-27.27,0 -27.27,-41.46 0,-41.46l114.97 0c27.27,0 27.27,41.46 0,41.46l-114.97 0zm-227.78 -147.76l138.84 0c11.45,0 20.73,9.28 20.73,20.73l0 138.84c0,11.45 -9.28,20.73 -20.73,20.73l-138.84 0c-11.45,0 -20.74,-9.28 -20.74,-20.73l0 -138.84c0,-11.45 9.29,-20.73 20.74,-20.73zm118.1 41.46l-97.37 0 0 97.38 97.37 0 0 -97.38zm178.97 427.3l-136.42 0 0 73.74 136.42 0 0 -73.74zm320.69 -126.68l36.85 46.69c16.82,21.28 -15.58,46.87 -32.39,25.59l-36.85 -46.68c-15.98,8.47 -34.21,13.28 -53.57,13.28 -63.21,0 -114.46,-51.25 -114.46,-114.47 0,-63.22 51.24,-114.48 114.46,-114.48 63.22,0 114.48,51.26 114.48,114.48 0,28.97 -10.77,55.43 -28.52,75.59zm-85.96 -148.6c-40.32,0 -73,32.69 -73,73.01 0,40.32 32.68,73 73,73 40.32,0 73.01,-32.68 73.01,-73 0,-40.32 -32.69,-73.01 -73.01,-73.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancy);
export default __webpack_public_path__ + "static/media/vacancy.58b6841f6b8bf93645d0292a28823875.svg";
export { ForwardRef as ReactComponent };